@if (isOpen) {
<div class="scan-overlay" appBodyPortal [class.scan-overlay--success]="scanSuccess" role="dialog" aria-modal="true"
  aria-labelledby="scan-title" data-testid="barcode-scan-overlay">
  <div class="scan-sheet" [class.scan-sheet--success]="scanSuccess">
    <div class="scan-sheet-header">
      <h3 id="scan-title">{{ scanSuccess ? 'ברקוד זוהה' : 'סריקת ברקוד' }}</h3>
      @if (!scanSuccess) {
      <div class="scan-header-actions">
        @if (scanTorchAvailable) {
        <button type="button" class="scan-torch" [class.scan-torch--on]="scanTorchOn"
          data-testid="barcode-scan-torch" [attr.aria-pressed]="scanTorchOn" (click)="toggleTorch()">
          פנס
        </button>
        }
        <button type="button" class="scan-close" data-testid="barcode-scan-close" (click)="stopScan()">
          סגור
        </button>
      </div>
      }
    </div>
    <p class="scan-hint">
      @if (scanSuccess) {
      מעבירים לחיפוש…
      } @else {
      החזיקו את גב האריזה כך שהברקוד בתוך המסגרת.
      @if (savePackagePhoto) {
      <span class="scan-hint-save">תמונת האריזה נשמרת עם הברקוד.</span>
      }
      }
    </p>
    <div class="scan-stage" [class.scan-stage--success]="scanSuccess">
      <video #scanVideo class="scan-video" [class.scan-video--hidden]="scanSuccess && !!scanFreezeUrl"
        playsinline muted autoplay (click)="refocusScan()"></video>
      @if (!scanSuccess) {
      <div class="scan-aim" aria-hidden="true">
        <span class="scan-aim-frame"></span>
      </div>
      }
      @if (scanSuccess && scanFreezeUrl) {
      <img class="scan-video scan-video--frozen" [src]="scanFreezeUrl" alt="" aria-hidden="true" />
      }
      @if (scanSuccess) {
      <div class="scan-success" data-testid="barcode-scan-success" aria-live="polite">
        <div class="scan-success-mark" aria-hidden="true">
          <span class="scan-success-ring"></span>
          <span class="scan-success-check">
            <svg viewBox="0 0 48 48" width="40" height="40" focusable="false">
              <path d="M14 25.5 21 32.5 34 16.5" fill="none" stroke="currentColor" stroke-width="4.5"
                stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </span>
        </div>
        @if (scanSuccessCode) {
        <p class="scan-success-code" dir="ltr">{{ scanSuccessCode }}</p>
        }
      </div>
      }
    </div>
    @if (scanError) {
    <p class="scan-error" role="alert">{{ scanError }}</p>
    }
  </div>
</div>
}
